export default "__VITE_ASSET__6d300672__"